import React from "react"

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'

import "./techstack.scss"

import ImgTechStack1 from "../../images/techstack/php.svg"
import ImgTechStack2 from "../../images/techstack/nette.svg"
import ImgTechStack3 from "../../images/techstack/mysql.svg"
import ImgTechStack4 from "../../images/techstack/elasticsearch.svg"
import ImgTechStack5 from "../../images/techstack/angular.svg"
import ImgTechStack6 from "../../images/techstack/powerbi.svg"
import ImgTechStack7 from "../../images/techstack/bootstrap.svg"
import ImgTechStack8 from "../../images/techstack/bitbucket.svg"
import ImgTechStack9 from "../../images/techstack/trello.svg"
import ImgTechStack10 from "../../images/techstack/slack.svg"
import ImgTechStack11 from "../../images/techstack/jenkins.svg"
import ImgTechStack12 from "../../images/techstack/sentry.svg"
import ImgTechStack13 from "../../images/techstack/docker.svg"
import ImgTechStack14 from "../../images/techstack/kubernetes.svg"
import ImgTechStack15 from "../../images/techstack/aws.svg"

const Techstack = (props) => (

    <div className="ftrs-techstack">
        <Container className="pt-5 pb-5">
            <h2 className="ftrs-h2 mb-5" data-sal="fade" data-sal-duration="1000">
                {
                    props.lang === 'cs' ? "Náš techstack" 
                    : props.lang === 'de' ? "Unser Tech Stack" 
                    : "Our Techstack"
                }
            </h2>
            <Row>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack1} alt="PHP" />
                    </div>
                    <div className="ftrs-techstack__header">PHP</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack2} alt="Nette" />
                    </div>
                    <div className="ftrs-techstack__header">Nette</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack3} alt="Mysql" />
                    </div>
                    <div className="ftrs-techstack__header">Mysql</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack4} alt="Elasticsearch" />
                    </div>
                    <div className="ftrs-techstack__header">Elasticsearch</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack13} alt="Docker" />
                    </div>
                    <div className="ftrs-techstack__header">Docker</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack14} alt="Kubernetes" />
                    </div>
                    <div className="ftrs-techstack__header">Kubernetes</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack15} alt="Aws" />
                    </div>
                    <div className="ftrs-techstack__header">Aws</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack5} alt="AngularJS" />
                    </div>
                    <div className="ftrs-techstack__header">AngularJS</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack6} alt="Power BI" />
                    </div>
                    <div className="ftrs-techstack__header">Power BI</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack8} alt="Bitbucket" />
                    </div>
                    <div className="ftrs-techstack__header">Bitbucket</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack9} alt="Trello" />
                    </div>
                    <div className="ftrs-techstack__header">Trello</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack11} alt="Jenkins" />
                    </div>
                    <div className="ftrs-techstack__header">Jenkins</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack12} alt="Sentry" />
                    </div>
                    <div className="ftrs-techstack__header">Sentry</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack7} alt="Bootstrap" />
                    </div>
                    <div className="ftrs-techstack__header">Bootstrap</div>
                </Col>
                <Col xs="4" lg="3" xl="2" data-sal="fade" data-sal-duration="1000">
                    <div className="ftrs-techstack__item">
                        <img loading="lazy" className="ftrs-techstack__img" src={ImgTechStack10} alt="Slack" />
                    </div>
                    <div className="ftrs-techstack__header">Slack</div>
                </Col>
            </Row>
        </Container>
    </div>

)

export default Techstack